import api from "../../config/base";
import {
  FETCH_MACHINES_REQUEST,
  FETCH_MACHINES_SUCCESS,
  FETCH_MACHINES_FAILURE,
  FETCH_MACHINE_REQUEST,
  FETCH_MACHINE_SUCCESS,
  FETCH_MACHINE_FAILURE,
  CREATE_MACHINE_REQUEST,
  CREATE_MACHINE_SUCCESS,
  CREATE_MACHINE_FAILURE,
  UPDATE_MACHINE_REQUEST,
  UPDATE_MACHINE_SUCCESS,
  UPDATE_MACHINE_FAILURE,
  DELETE_MACHINE_REQUEST,
  DELETE_MACHINE_SUCCESS,
  DELETE_MACHINE_FAILURE,
  ACTIVE_MACHINE_REQUEST,
  ACTIVE_MACHINE_SUCCESS,
  ACTIVE_MACHINE_FAILURE,
  FREE_MACHINES_REQUEST,
  FREE_MACHINES_SUCCESS,
  FREE_MACHINES_FAILURE,
} from "./types";

// Fetch all machines
export const fetchMachines = () => async (dispatch) => {
  dispatch({ type: FETCH_MACHINES_REQUEST });
  try {
    const response = await api.get("/machines");
    dispatch({ type: FETCH_MACHINES_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_MACHINES_FAILURE, payload: error.message });
  }
};

// Fetch all free machines
export const fetchFreeMachines = () => async (dispatch) => {
  dispatch({ type: FREE_MACHINES_REQUEST });
  try {
    console.log('ssssss')
    const response = await api.get("/machines/free");
    dispatch({ type: FREE_MACHINES_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FREE_MACHINES_FAILURE, payload: error.message });
  }
};

// Fetch a single machine
export const fetchMachine = (id) => async (dispatch) => {
  dispatch({ type: FETCH_MACHINE_REQUEST });
  try {
    const response = await api.get(`/machines/${id}`);
    dispatch({ type: FETCH_MACHINE_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_MACHINE_FAILURE, payload: error.message });
  }
};

// Create a new machine
export const createMachine = (machine) => async (dispatch) => {
  dispatch({ type: CREATE_MACHINE_REQUEST });
  try {
    const response = await api.post("/machines", machine);
    dispatch({ type: CREATE_MACHINE_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: CREATE_MACHINE_FAILURE, payload: error.message });
  }
};

// Update a machine
export const updateMachine = (id, machine) => async (dispatch) => {
  dispatch({ type: UPDATE_MACHINE_REQUEST });
  try {
    const response = await api.put(`/machines/${id}`, machine);
    dispatch({ type: UPDATE_MACHINE_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: UPDATE_MACHINE_FAILURE, payload: error.message });
  }
};

// Delete a machine
export const deleteMachine = (id) => async (dispatch) => {
  dispatch({ type: DELETE_MACHINE_REQUEST });
  try {
    await api.delete(`/machines/${id}`);
    dispatch({ type: DELETE_MACHINE_SUCCESS, payload: id });
  } catch (error) {
    dispatch({ type: DELETE_MACHINE_FAILURE, payload: error.message });
  }
};

// Activate machine
export const activeMachine = (id, machine) => async (dispatch) => {
  dispatch({ type: ACTIVE_MACHINE_REQUEST });
  try {
    const response = await api.put(`/machines/active/${id}`, machine);
    dispatch({ type: ACTIVE_MACHINE_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: ACTIVE_MACHINE_FAILURE, payload: error.message });
  }
};
